import React from 'react';
import {Button, Stack, Typography} from '@mui/material';
import AddCommentOutlinedIcon from '@mui/icons-material/AddCommentOutlined';

const ChatHeader = ({title, documentId, documentTitle, conversationId, onStartNewConversation}) => {
    const trimmedDocumentTitle = documentTitle?.trim();
    const productLabel = trimmedDocumentTitle || (documentId ? `Document ${documentId}` : null);

    return (
        <Stack
            direction="row"
            alignItems="center"
            justifyContent="space-between"
            spacing={1}
            px={2}
            py={1.25}
            bgcolor="grey.50"
            borderBottom={1}
            borderColor="divider"
        >
            <Stack spacing={0.25} minWidth={0}>
                <Typography variant="subtitle1" fontWeight={600} noWrap>
                    {title}
                </Typography>
                {productLabel ? (
                    <Typography variant="caption" color="text.secondary" noWrap>
                        Context → Product → <strong>{productLabel}</strong>
                    </Typography>
                ) : null}
            </Stack>

            <Button
                size="small"
                variant="text"
                startIcon={<AddCommentOutlinedIcon fontSize="small"/>}
                onClick={onStartNewConversation}
            >
                New chat
            </Button>
        </Stack>
    );
};

export default ChatHeader;
